export class AsyncTaskError extends Error {
  name = 'AsyncTaskError'

  constructor ({ code, message, context }) {
    super(message)
    Error.captureStackTrace(this, AsyncTaskError)

    this.message = String(message)
    this.code = code
    this.context = context
  }
}

export class ValidationError extends Error {
  name = 'ValidationError'
  code = 422

  constructor ({ errors, errorMessage }) {
    super(errorMessage)

    this.errorMessage = errorMessage || null
    this.errors = errors
  }
}

export class UnauthorizedError extends Error {
  name = 'UnauthorizedError'
  code = 401
}

export class BadRequestError extends Error {
  name = 'BadRequestError'
  code = 400

  constructor ({ errors }) {
    super()

    this.errors = errors
  }
}

export class ServiceUnavailableError extends Error {
  name = 'ServiceUnavailableError'
  code = 503
}

export class InternalServerError extends Error {
  name = 'InternalServerError'
  code = 500
}
